// ─── Journal d'activité (RBAC stage d, 2026-07-17) — append-only viewer ─────
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AdminLayout } from '@/components/AdminLayout';
import { Button } from '@/components/ui/Button';
import { usersApi } from '@/lib/api';
import { useT } from '@/lib/i18n';

export default function AdminAuditPage() {
  const { t } = useT();
  const [before, setBefore] = useState<string | undefined>(undefined);
  const { data, isLoading } = useQuery({
    queryKey: ['audit-log', before],
    queryFn: () => usersApi.auditLog(before),
  });
  const entries = data?.entries ?? [];
  return (
    <AdminLayout>
      <div className="max-w-4xl mx-auto space-y-3">
        <div>
          <h1 className="text-lg font-semibold text-gray-800" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>{t("Journal d'activité")}</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">{t('Immuable — aucune entrée ne peut être modifiée ou supprimée, par personne.')}</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-50">
          {isLoading && <p className="p-4 text-sm text-gray-400">{t('Chargement…')}</p>}
          {entries.map((e) => (
            <div key={e.id} className="px-4 py-2.5 flex items-baseline gap-3 text-[12.5px]">
              <span className="text-gray-400 shrink-0 tabular-nums">{new Date(e.at).toLocaleString('fr-FR')}</span>
              <span className="font-semibold text-gray-700 shrink-0">{e.actor_email ?? '—'}</span>
              <span className="px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 text-[10.5px] font-mono shrink-0">{e.action}</span>
              <span className="text-gray-600 truncate">{e.summary}{e.entity_id ? ` · ${e.entity_id}` : ''}</span>
            </div>
          ))}
          {!isLoading && entries.length === 0 && <p className="p-4 text-sm text-gray-400">{t('Aucune entrée')}</p>}
        </div>
        {entries.length >= 100 && (
          <Button size="sm" variant="secondary" onClick={() => setBefore(entries[entries.length - 1].at)}>{t('Voir plus ancien')}</Button>
        )}
      </div>
    </AdminLayout>
  );
}
